<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "div",
        { staticClass: "post-created" },
        [
          _c("validation-observer", {
            ref: "createPost",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var invalid = ref.invalid
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.createPost($event)
                          },
                        },
                      },
                      [
                        _c("div", {}, [
                          _c("div", { staticClass: "download-order-report" }, [
                            _c("div", { staticClass: "d-flex mb-1" }, [
                              _c(
                                "h3",
                                { staticClass: "mb-0 back_button" },
                                [
                                  _c("BackButton"),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("ads.Post-Ad"))),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "post-created-outer" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-tabs",
                                      attrs: { sm: "12", lg: "12" },
                                    },
                                    [
                                      _c("TabsButton", {
                                        attrs: {
                                          handleTabChange: _vm.handleTabChange,
                                          tabText1: _vm.$t("ads.Buy"),
                                          tabText2: _vm.$t("ads.Sell"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t("ads.Coin"),
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex custom-label",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "bv-no-focus-ring col-form-label pt-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ads.Coin"
                                                                  )
                                                                ) + " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s("*") +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c("CurrencySelect", {
                                                        attrs: {
                                                          name: _vm.$t(
                                                            "ads.Coin"
                                                          ),
                                                          autocomplete: "off",
                                                          clearable: false,
                                                          options: _vm.coins,
                                                        },
                                                        model: {
                                                          value: _vm.coin,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.coin = $$v
                                                          },
                                                          expression: "coin",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t("ads.For-Fiat"),
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex custom-label",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "bv-no-focus-ring col-form-label pt-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "ads.For-Fiat"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s("*") +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c("CountrySelect", {
                                                        attrs: {
                                                          name: _vm.$t(
                                                            "ads.For-Fiat"
                                                          ),
                                                          autocomplete: "off",
                                                          clearable: false,
                                                          reduce:
                                                            "currencyCode",
                                                          label: "currencyCode",
                                                          imageURLName:
                                                            "currencyImgUrl",
                                                        },
                                                        model: {
                                                          value: _vm.fiat,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.fiat = $$v
                                                          },
                                                          expression: "fiat",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        { staticClass: "post-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex custom-label",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "bv-no-focus-ring col-form-label pt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("ads.Unit-price")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s("*") + " ")]
                                              ),
                                            ]
                                          ),
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t("ads.Unit-price"),
                                              rules: {
                                                required: true,
                                                maxAmount:
                                                  _vm.fixedPriceUpperLimit,
                                                minAmount:
                                                  _vm.fixedPriceLowerLimit,
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "b-input-group",
                                                        {
                                                          staticClass:
                                                            "input-group-merge",
                                                          attrs: {
                                                            append: _vm.fiat,
                                                            label:
                                                              _vm.$t(
                                                                "ads.Unit-price"
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              type: "number",
                                                              placeholder:
                                                                "0.0",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.unitPrice,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.unitPrice =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "unitPrice",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c("Errors", {
                                                        staticClass:
                                                          "min-height-post",
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "info-post" }, [
                                        _c(
                                          "div",
                                          { staticClass: "info-price" },
                                          [
                                            _vm.marketPrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "info-detail",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "gray-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ads.Market-price"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "black-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.marketPrice
                                                            ) +
                                                            " " +
                                                            _vm._s(_vm.fiat) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.highestPrice
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "info-detail",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "gray-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ads.Highest-price"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "black-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.highestPrice
                                                            ) +
                                                            " " +
                                                            _vm._s(_vm.fiat) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        { staticClass: "post-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex custom-label",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "bv-no-focus-ring col-form-label pt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("ads.Quantity")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s("*") + " ")]
                                              ),
                                            ]
                                          ),
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t("ads.Quantity"),
                                              rules: {
                                                required: true,
                                                maxQuantity:
                                                  _vm.orderType === "SELL" &&
                                                  _vm.maxQty >
                                                    _vm.availableBalance
                                                    ? _vm.availableBalance
                                                    : _vm.maxQty,
                                                minQuantity: _vm.minQty,
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "b-input-group",
                                                        {
                                                          staticClass:
                                                            "input-group-merge",
                                                          attrs: {
                                                            append: _vm.coin,
                                                            label:
                                                              _vm.$t(
                                                                "ads.Quantity"
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              type: "number",
                                                              placeholder:
                                                                "0.0",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.totalQuantity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.totalQuantity =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "totalQuantity",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c("Errors", {
                                                        staticClass:
                                                          "min-height-post",
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "info-post right-txt" },
                                        [
                                          _vm.totalUnitQuality
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "black-info totalUnitQuality",
                                                },
                                                [
                                                  _c("IconSp"),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.totalUnitQuality
                                                    ) +
                                                      " " +
                                                      _vm._s(_vm.fiat) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row bottom-1rem" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("ads.Orders-limit"),
                                          rules: {
                                            required: true,
                                            maxOrderLimit:
                                              _vm.maxOrderPriceLimit,
                                            minOrderLimit:
                                              _vm.minOrderPriceLimit,
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex custom-label",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "bv-no-focus-ring col-form-label pt-0",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ads.Orders-limit"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s("*") + " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      staticClass:
                                                        "input-group-merge",
                                                      attrs: {
                                                        prepend:
                                                          _vm.$t("ads.Min"),
                                                        append: _vm.fiat,
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          placeholder: "0.0",
                                                          type: "number",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.minOrderPriceLimitData,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.minOrderPriceLimitData =
                                                              $$v
                                                          },
                                                          expression:
                                                            "minOrderPriceLimitData",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "6" } },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("ads.Orders-Max-limit"),
                                          rules: {
                                            required: true,
                                            maxOrderLimit:
                                              _vm.maxOrderPriceLimit,
                                            minOrderLimit:
                                              _vm.minOrderPriceLimitData ||
                                              _vm.minOrderPriceLimit,
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("label", {
                                                    staticClass:
                                                      "bv-no-focus-ring col-form-label pt-0",
                                                    staticStyle: {
                                                      "min-height": "21px",
                                                    },
                                                  }),
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      staticClass:
                                                        "input-group-merge",
                                                      attrs: {
                                                        prepend:
                                                          _vm.$t("ads.Max"),
                                                        append: _vm.fiat,
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          placeholder: "0.0",
                                                          type: "number",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.maxOrderPriceLimitData,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.maxOrderPriceLimitData =
                                                              $$v
                                                          },
                                                          expression:
                                                            "maxOrderPriceLimitData",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex custom-label",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "bv-no-focus-ring col-form-label pt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ads.Payment-Method"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s("*") + " ")]
                                              ),
                                            ]
                                          ),
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "ads.Payment-Method"
                                              ),
                                              rules: {
                                                required: true,
                                                maxSelectionRule:
                                                  _vm.maxPayMethodCount,
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "custom-add-pay",
                                                        },
                                                        [
                                                          _c(
                                                            "PaymentMethodSelect",
                                                            {
                                                              attrs: {
                                                                multiple: true,
                                                                options:
                                                                  _vm.paymentMethodsOptions,
                                                                showAddPaymentMethod:
                                                                  _vm.showAddPaymentMethod,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paymentMethods,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.paymentMethods =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "paymentMethods",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "b-button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover.v-primary",
                                                                  modifiers: {
                                                                    hover: true,
                                                                    "v-primary": true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "btn-icon rounded-circle",
                                                              attrs: {
                                                                title: _vm.$t(
                                                                  "ads.addNewPaymentMethod"
                                                                ),
                                                                variant:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openAddPayment(
                                                                      true
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "feather-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "PlusIcon",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex custom-label",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "bv-no-focus-ring col-form-label pt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ads.Payment-Time-Limit"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s("*") + " ")]
                                              ),
                                            ]
                                          ),
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "ads.Payment-Time-Limit"
                                              ),
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("v-select", {
                                                        attrs: {
                                                          options:
                                                            _vm.formattedOptions,
                                                          label: "label",
                                                          reduce: function (
                                                            option
                                                          ) {
                                                            return option.id
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.paymentTimeLimit,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.paymentTimeLimit =
                                                              $$v
                                                          },
                                                          expression:
                                                            "paymentTimeLimit",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "post-create-row" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12", lg: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "ads.Trading-terms-Optional"
                                            ),
                                          },
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "ads.Trading-terms-Optional"
                                              ),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          rows: "3",
                                                          "no-resize": "",
                                                        },
                                                        model: {
                                                          value: _vm.terms,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.terms = $$v
                                                          },
                                                          expression: "terms",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "submit-button" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { variant: "outline-secondary" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("ads.Cancel")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled: invalid || _vm.isLoading,
                                        type: "submit",
                                        variant: "primary",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("ads.Post")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("AddPaymentMethod", {
        attrs: {
          AddPayment: _vm.AddPayment,
          closePaymentPop: _vm.closePaymentPop,
        },
      }),
      _c("KycNotComplete", {
        attrs: {
          showPop: _vm.warningPop,
          onModalHidden: _vm.onModalHidden,
          msg: _vm.warningMsg,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/myads/postAd.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import core_components_tabs_Tabs_vue from '@core/components/tabs/Tabs.vue';
import layouts_components_CurrencySelect_vue from '@/layouts/components/CurrencySelect.vue';
import layouts_components_CountrySelect_vue from '@/layouts/components/CountrySelect.vue';
import * as vuex from 'vuex';
import layouts_components_PaymentMethodSelect_vue from '@/layouts/components/PaymentMethodSelect.vue';
import * as veevalidate from 'vee-validate';
import assets_rashi_coin_icon_sp_svg from '@/assets/rashi-coin/icon-sp.svg';
import validations from '@validations';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import EventBus from '@/EventBus';
import layouts_components_AddPaymentMethod_vue from '@/layouts/components/AddPaymentMethod.vue';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
import layouts_components_BackButton_vue from '@/layouts/components/BackButton.vue';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BAvatar: bootstrapvue["BAvatar"],
    vSelect: vue_select,
    BFormInput: bootstrapvue["BFormInput"],
    BFormGroup: bootstrapvue["BFormGroup"],
    TabsButton: core_components_tabs_Tabs_vue,
    BFormTextarea: bootstrapvue["BFormTextarea"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BInputGroup: bootstrapvue["BInputGroup"],
    CurrencySelect: layouts_components_CurrencySelect_vue,
    PaymentMethodSelect: layouts_components_PaymentMethodSelect_vue,
    BForm: bootstrapvue["BForm"],
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    CountrySelect: layouts_components_CountrySelect_vue,
    IconSp: assets_rashi_coin_icon_sp_svg,
    AddPaymentMethod: layouts_components_AddPaymentMethod_vue,
    KycNotComplete: layouts_components_KycNotComplete_vue,
    BackButton: layouts_components_BackButton_vue,
    Errors: layouts_components_Errors_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  computed: {
    ...vuex.mapState("user", ["coins", "user", "refData"]),
    formattedOptions() {
      return this.option.map(time => {
        const minutes = parseInt(time.value);
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const label = (hours > 0 ? hours + "hr " : "") + (remainingMinutes > 0 ? remainingMinutes + "min" : "");
        return {
          id: time.id,
          label
        };
      });
    }
  },
  data() {
    return {
      text: "",
      AddPayment: false,
      option: [{
        id: "15",
        value: "15"
      }, {
        id: "30",
        value: "30"
      }, {
        id: "45",
        value: "45"
      }, {
        id: "60",
        value: "60"
      }, {
        id: "180",
        value: "180"
      }, {
        id: "240",
        value: "240"
      }],
      orderType: "BUY",
      fiat: "",
      coin: "",
      unitPrice: null,
      totalQuantity: null,
      maxOrderPriceLimitData: null,
      minOrderPriceLimitData: null,
      paymentMethods: [],
      paymentTimeLimit: null,
      terms: null,
      isLoading: false,
      required: validations["required"],
      lang: this.$route.params.lang,
      paymentMethodsOptions: [],
      showAddPaymentMethod: false,
      marketPrice: 0,
      highestPrice: 0,
      totalUnitQuality: 0,
      minQty: 0,
      maxQty: 0,
      lowestPrice: 0,
      defaultCoin: "",
      maxPayMethodCount: 0,
      fixedPriceLowerLimit: 10,
      fixedPriceUpperLimit: 100,
      maxOrderPriceLimit: 0,
      minOrderPriceLimit: 0,
      minAmount: validations["minAmount"],
      maxAmount: validations["maxAmount"],
      minQuantity: validations["minQuantity"],
      maxQuantity: validations["maxQuantity"],
      maxOrderLimit: validations["maxOrderLimit"],
      minOrderLimit: validations["minOrderLimit"],
      maxSelectionRule: validations["maxSelectionRule"],
      debounceTimeout: null,
      warningPop: false,
      warningMsg: "",
      availableBalance: 0
    };
  },
  created() {
    EventBus.$on("getAllPayment", this.getAllPayment);
  },
  watch: {
    orderType(newVal, oldVal) {
      if (newVal && oldVal !== newVal) {
        this.callDebounce();
        if (this.orderType === "SELL" && !this.availableBalance) {
          this.getBalance();
        }
      }
    },
    fiat(newVal, oldVal) {
      if (newVal && oldVal !== newVal) this.callDebounce();
    },
    coin(newVal, oldVal) {
      if (newVal && oldVal !== newVal) {
        this.callDebounce();
        this.getBalance();
      }
    },
    user(newVal, oldVal) {
      if (newVal && oldVal !== newVal && !this.fiat) this.fiat = newVal.currencyCode;
    },
    refData(newVal, oldVal) {
      if (newVal && oldVal !== newVal && !this.coin) {
        this.coin = newVal.defaultCoin;
      }
    },
    unitPrice(newVal, oldVal) {
      if (!isNaN(newVal) && !isNaN(this.totalQuantity)) {
        this.totalUnitQuality = Number(newVal) * Number(this.totalQuantity);
      } else {
        this.totalUnitQuality = 0;
      }
    },
    totalQuantity(newVal, oldVal) {
      if (!isNaN(newVal) && !isNaN(this.unitPrice)) {
        this.totalUnitQuality = Number(newVal) * Number(this.unitPrice);
      } else {
        this.totalUnitQuality = 0;
      }
    }
  },
  mounted() {
    this.fiat = this.user.currencyCode;
    this.coin = this.refData.defaultCoin;
    this.getAllPayment();
    // this.getAdRefData();
  },
  methods: {
    callDebounce() {
      const debounceTime = 500;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        this.getAdRefData();
      }, debounceTime);
    },
    onModalHidden(props) {
      this.warningPop = props;
    },
    openAddPayment(flag) {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteForPayment", {
          add: "add"
        });
        return;
      }
      this.AddPayment = flag;
    },
    closePaymentPop(flag) {
      this.AddPayment = false;
      if (flag) {
        this.getAllPayment();
      }
    },
    handleTabChange(tabNumber) {
      if (tabNumber === 1) {
        this.orderType = "BUY";
      } else if (tabNumber === 2) {
        this.orderType = "SELL";
      }
    },
    async getAllPayment() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/payment/all`
        }, {
          page: 1,
          size: 100
        }, {
          isLoading: true
        });
        if (res && res.userPaymentMethodList) {
          this.paymentMethodsOptions = res.userPaymentMethodList.map(item => {
            return {
              name: `${item.paymentMethod} : ${item.accountId}`,
              paymentMethod: item.paymentMethod,
              accountId: item.accountId,
              config: item.config,
              id: item.id
            };
          });
          if (this.paymentMethodsOptions && !this.paymentMethodsOptions.length) {
            this.showAddPaymentMethod = true;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getAdRefData() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: "p2p/ad/refdata"
        }, {
          orderType: this.orderType,
          coin: this.coin || this.defaultCoin || "USDT",
          fiat: this.fiat
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.minQty = res.minQty;
          this.maxQty = res.maxQty;
          this.marketPrice = res.marketPrice;
          this.fixedPriceUpperLimit = res.fixedPriceUpperLimit;
          this.fixedPriceLowerLimit = res.fixedPriceLowerLimit;
          this.highestPrice = res.highestPrice;
          this.lowestPrice = res.lowestPrice;
          this.minOrderPriceLimit = res.minOrderPriceLimit;
          this.maxOrderPriceLimit = res.maxOrderPriceLimit;
          this.maxPayMethodCount = res.maxPayMethodCount;
          this.option = res.paymentTimeLimit;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async createPost() {
      try {
        const res = await new libs_api_api().api({
          method: "post",
          url: "p2p/ad/save"
        }, {
          orderType: this.orderType,
          coin: this.coin,
          fiat: this.fiat,
          rate: this.unitPrice,
          totalQuantity: this.totalQuantity,
          minOrderPriceLimit: this.minOrderPriceLimitData,
          maxOrderPriceLimit: this.maxOrderPriceLimitData,
          paymentMethodIds: this.paymentMethods,
          paymentTimeLimit: this.paymentTimeLimit,
          terms: this.terms
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("ads.postCreatedSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.$router.push({
            name: "my-ads",
            params: {
              lang: this.lang || undefined
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getBalance() {
      try {
        if (this.coin) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `asset/balance`
          }, {
            asset: this.coin
          }, {
            isLoading: true
          });
          if (res && res.availableBalance) {
            this.availableBalance = res.availableBalance;
            // this.availableBalance = res.totalBalance;
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } else {
          this.availableBalance = 0;
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/myads/postAd.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.v-select {
  position: relative;
  font-family: inherit;
}
.v-select,
.v-select * {
  box-sizing: border-box;
}

/* KeyFrames */
@-webkit-keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@-webkit-keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
@keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
/* Dropdown Default Transition */
.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0;
}

/** Component States */
/*
 * Disabled
 *
 * When the component is disabled, all interaction
 * should be prevented. Here we modify the bg color,
 * and change the cursor displayed on the interactive
 * components.
 */
[dir] .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f8f8f8;
}

/*
 *  RTL - Right to Left Support
 *
 *  Because we're using a flexbox layout, the `dir="rtl"`
 *  HTML attribute does most of the work for us by
 *  rearranging the child elements visually.
 */
.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px;
}
.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0;
}
.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px;
}
.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right;
}

/**
    Dropdown Toggle

    The dropdown toggle is the primary wrapper of the component. It
    has two direct descendants: .vs__selected-options, and .vs__actions.

    .vs__selected-options holds the .vs__selected's as well as the
    main search input.

    .vs__actions holds the clear button and dropdown toggle.
 */
.vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
}
[dir] .vs__dropdown-toggle {
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
[dir] .vs__selected-options {
  padding: 0 2px;
}
.vs__actions {
  display: flex;
  align-items: center;
}
[dir=ltr] .vs__actions {
  padding: 4px 6px 0 3px;
}
[dir=rtl] .vs__actions {
  padding: 4px 3px 0 6px;
}

/* Dropdown Toggle States */
[dir] .vs--searchable .vs__dropdown-toggle {
  cursor: text;
}
[dir] .vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir] .vs__open-indicator {
  transform: scale(1);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir=ltr] .vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1);
}
[dir=rtl] .vs--open .vs__open-indicator {
  transform: rotate(-180deg) scale(1);
}
.vs--loading .vs__open-indicator {
  opacity: 0;
}

/* Clear Button */
.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__clear {
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
[dir=ltr] .vs__clear {
  margin-right: 8px;
}
[dir=rtl] .vs__clear {
  margin-left: 8px;
}

/* Dropdown Menu */
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  z-index: 1000;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  list-style: none;
}
[dir] .vs__dropdown-menu {
  padding: 5px 0;
  margin: 0;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d6de;
  border-top-style: none;
  border-radius: 0 0 0.357rem 0.357rem;
  background: #fff;
}
[dir=ltr] .vs__dropdown-menu {
  left: 0;
  text-align: left;
}
[dir=rtl] .vs__dropdown-menu {
  right: 0;
  text-align: right;
}
[dir] .vs__no-options {
  text-align: center;
}

/* List Items */
.vs__dropdown-option {
  line-height: 1.42857143;
  /* Normalize line height */
  display: block;
  color: #333;
  /* Overrides most CSS frameworks */
  white-space: nowrap;
}
[dir] .vs__dropdown-option {
  padding: 3px 20px;
  clear: both;
}
[dir] .vs__dropdown-option:hover {
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #8dc540 !important;
}
[dir] .vs__dropdown-option--highlight {
  background: rgba(141, 197, 64, 0.12);
}
.vs__dropdown-option--disabled {
  color: rgba(60, 60, 60, 0.5);
}
[dir] .vs__dropdown-option--disabled {
  background: inherit;
}
[dir] .vs__dropdown-option--disabled:hover {
  cursor: inherit;
}

/* Selected Tags */
.vs__selected {
  display: flex;
  align-items: center;
  color: #333;
  line-height: 1.8;
  z-index: 0;
}
[dir] .vs__selected {
  background-color: #8dc540;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}
.vs__deselect {
  display: inline-flex;
  appearance: none;
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__deselect {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  text-shadow: 0 1px 0 #fff;
}
[dir=ltr] .vs__deselect {
  margin-left: 4px;
}
[dir=rtl] .vs__deselect {
  margin-right: 4px;
}

/* States */
[dir] .vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent;
}
.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: 0.4;
}
.vs--single.vs--searching .vs__selected {
  display: none;
}

/* Search Input */
/**
 * Super weird bug... If this declaration is grouped
 * below, the cancel button will still appear in chrome.
 * If it's up here on it's own, it'll hide it.
 */
.vs__search::-webkit-search-cancel-button {
  display: none;
}
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration,
.vs__search::-ms-clear {
  display: none;
}
.vs__search,
.vs__search:focus {
  appearance: none;
  line-height: 1.8;
  font-size: 1em;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}
[dir] .vs__search, [dir] .vs__search:focus {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
}
[dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
  border-left: none;
}
[dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
  border-right: none;
}
.vs__search::placeholder {
  color: #6e6b7b;
}

/**
    States
 */
.vs--unsearchable .vs__search {
  opacity: 1;
}
[dir] .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer;
}
.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 0.2;
}

/* Loading Spinner */
.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  transition: opacity 0.1s;
}
[dir] .vs__spinner {
  border-top: 0.9em solid rgba(100, 100, 100, 0.1);
  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
  transform: translateZ(0);
}
[dir=ltr] .vs__spinner {
  border-right: 0.9em solid rgba(100, 100, 100, 0.1);
  border-left: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-ltr 1.1s infinite linear;
}
[dir=rtl] .vs__spinner {
  border-left: 0.9em solid rgba(100, 100, 100, 0.1);
  border-right: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-rtl 1.1s infinite linear;
}
.vs__spinner,
.vs__spinner:after {
  width: 5em;
  height: 5em;
}
[dir] .vs__spinner, [dir] .vs__spinner:after {
  border-radius: 50%;
}

/* Loading Spinner States */
.vs--loading .vs__spinner {
  opacity: 1;
}
.vs__open-indicator {
  fill: none;
}
[dir] .vs__open-indicator {
  margin-top: 0.15rem;
}
.vs__dropdown-toggle {
  transition: all 0.25s ease-in-out;
}
[dir] .vs__dropdown-toggle {
  padding: 0.59px 0 4px 0;
}
[dir=ltr] .vs--single .vs__dropdown-toggle {
  padding-left: 6px;
}
[dir=rtl] .vs--single .vs__dropdown-toggle {
  padding-right: 6px;
}
.vs__dropdown-option--disabled {
  opacity: 0.5;
}
[dir] .vs__dropdown-option--disabled.vs__dropdown-option--selected {
  background: #8dc540 !important;
}
.vs__dropdown-option {
  color: #6e6b7b;
}
[dir] .vs__dropdown-option, [dir] .vs__no-options {
  padding: 7px 20px;
}
.vs__dropdown-option--selected {
  background-color: #8dc540;
  color: #fff;
  position: relative;
}
.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}
[dir=rtl] .vs__dropdown-option--selected::after {
  left: 20px;
  right: unset;
}
.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #8dc540 !important;
}
.vs__clear svg {
  color: #6e6b7b;
}
.vs__selected {
  color: #fff;
}
.v-select.vs--single .vs__selected {
  color: #6e6b7b;
  transition: transform 0.2s ease;
}
[dir] .v-select.vs--single .vs__selected {
  margin-top: 5px;
}
[dir=ltr] .v-select.vs--single .vs__selected input {
  padding-left: 0;
}
[dir=rtl] .v-select.vs--single .vs__selected input {
  padding-right: 0;
}
[dir=ltr] .vs--single.vs--open .vs__selected {
  transform: translateX(5px);
}
[dir=rtl] .vs--single.vs--open .vs__selected {
  transform: translateX(-5px);
}
.vs__selected .vs__deselect {
  color: inherit;
}
.v-select:not(.vs--single) .vs__selected {
  font-size: 0.9rem;
}
[dir] .v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}
[dir=rtl] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 5px 2px 2px;
}
.v-select:not(.vs--single) .vs__deselect svg {
  vertical-align: text-top;
}
[dir] .v-select:not(.vs--single) .vs__deselect svg {
  transform: scale(0.8);
}
.vs__dropdown-menu {
  top: calc(100% + 1rem);
}
[dir] .vs__dropdown-menu {
  border: none;
  border-radius: 6px;
  padding: 0;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-color: #8dc540;
  border-bottom-color: #8dc540;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.357rem;
  border-bottom-right-radius: 0.357rem;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0.357rem;
  border-bottom-left-radius: 0.357rem;
}
.select-size-lg .vs__selected {
  font-size: 1rem !important;
}
[dir] .select-size-lg.vs--single.vs--open .vs__selected {
  margin-top: 6px;
}
.select-size-lg .vs__dropdown-toggle,
.select-size-lg .vs__selected {
  font-size: 1.25rem;
}
[dir] .select-size-lg .vs__dropdown-toggle {
  padding: 5px;
}
[dir] .select-size-lg .vs__dropdown-toggle input {
  margin-top: 0;
}
.select-size-lg .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-lg .vs__deselect svg {
  transform: scale(1) !important;
}
[dir] .select-size-sm .vs__dropdown-toggle {
  padding-bottom: 0;
  padding: 1px;
}
[dir] .select-size-sm.vs--single .vs__dropdown-toggle {
  padding: 2px;
}
.select-size-sm .vs__dropdown-toggle,
.select-size-sm .vs__selected {
  font-size: 0.9rem;
}
[dir] .select-size-sm .vs__actions {
  padding-top: 2px;
  padding-bottom: 2px;
}
.select-size-sm .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-sm .vs__search {
  margin-top: 0;
}
.select-size-sm.v-select .vs__selected {
  font-size: 0.75rem;
}
[dir] .select-size-sm.v-select .vs__selected {
  padding: 0 0.3rem;
}
[dir] .select-size-sm.v-select:not(.vs--single) .vs__selected {
  margin: 4px 5px;
}
[dir] .select-size-sm.v-select.vs--single .vs__selected {
  margin-top: 1px;
}
[dir] .select-size-sm.vs--single.vs--open .vs__selected {
  margin-top: 4px;
}
.dark-layout .vs__dropdown-toggle {
  color: #b4b7bd;
}
[dir] .dark-layout .vs__dropdown-toggle {
  background: #283046;
  border-color: #404656;
}
.dark-layout .vs__selected-options input {
  color: #b4b7bd;
}
.dark-layout .vs__selected-options input::placeholder {
  color: #676d7d;
}
.dark-layout .vs__actions svg {
  fill: #404656;
}
[dir] .dark-layout .vs__dropdown-menu {
  background: #283046;
}
.dark-layout .vs__dropdown-menu li {
  color: #b4b7bd;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #8dc540;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgba(141, 197, 64, 0.12);
}
.dark-layout .v-select.vs--single .vs__selected {
  color: #b4b7bd !important;
}
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs--disabled .vs__clear,
.dark-layout .vs--disabled .vs__search,
.dark-layout .vs--disabled .vs__selected,
.dark-layout .vs--disabled .vs__open-indicator {
  opacity: 0.5;
}
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle, [dir] .dark-layout .vs--disabled .vs__clear, [dir] .dark-layout .vs--disabled .vs__search, [dir] .dark-layout .vs--disabled .vs__selected, [dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #283046;
}
.post-created-outer {
  width: 70%;
  max-width: 700px;
}[dir] .post-created-outer {
  margin: 0 auto;
}
.post-created-outer .form-tabs {
  display: flex;
  justify-content: center;
}
[dir] .post-created-outer .form-tabs {
  text-align: center;
  margin-bottom: 20px;
}
[dir] .post-created-outer .form-tabs .tab-slider--nav {
  margin: 0 auto;
}
.info-post {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
[dir] .info-post {
  margin-top: 10px;
  margin-bottom: 10px;
}
.info-post .info-price {
  display: flex;
}
.info-post .info-price .info-detail {
  display: flex;
}
[dir=ltr] .info-post .info-price .info-detail {
  padding-right: 15px;
}
[dir=rtl] .info-post .info-price .info-detail {
  padding-left: 15px;
}
.info-post .info-price .info-detail .gray-info {
  color: #929292;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}
.info-post .info-price .info-detail .black-info {
  color: #3d3d3d;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}
[dir=ltr] .info-post .info-price .info-detail .black-info {
  padding-left: 7px;
}
[dir=rtl] .info-post .info-price .info-detail .black-info {
  padding-right: 7px;
}
[dir] .bottom-1rem {
  margin-bottom: 1rem;
}
.right-txt {
  justify-content: flex-end;
}
[dir=ltr] .totalUnitQuality svg {
  margin-right: 6px;
}
[dir=rtl] .totalUnitQuality svg {
  margin-left: 6px;
}
.min-height-post {
  min-height: 18px;
  display: block !important;
}
[dir] .post-group {
  margin-bottom: 0px;
}
.custom-add-pay {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-add-pay .select-payment-drop-down {
  width: calc(100% - 50px);
}
.custom-add-pay .btn.btn-icon.rounded-circle.btn-primary {
  max-height: 40px;
  max-width: 40px;
  min-height: 40px;
  min-width: 40px;
}
@media only screen and (max-width: 991px) {
.post-created-outer {
    width: 100%;
}
}
</style>
